import { Middleware, SWRHook } from 'swr';

const SWRMiddleware: Middleware = (useSWRNext: SWRHook) => (key, fetcher, config) => {
    // Before hook runs...

    // Add config for all hooks
    const configuredConfig = {
        ...config,
        // onError: (error, key) => console.error(`Error on SWR for ${key}`, error),
        onSuccess: (_data, _key) => {
            // console.debug('SWRMiddleware', `Success on SWR for ${_key}`);
        }
    };

    // Add logger to the original fetcher.
    const extendedFetcher = (...args) => {
        return fetcher(...args);
    };

    // Handle the next middleware, or the `useSWR` hook if this is the last one.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const swr = useSWRNext(key, extendedFetcher, configuredConfig);

    // After hook runs...
    return swr;
};

export default SWRMiddleware;
